'use client';

import { TextPassage } from '@petsmart-ui/sparky';
import { useProductDetails } from '@app/pdp/hooks';

export default function ProductSku() {
    const { selectedProduct } = useProductDetails();

    return (
        <TextPassage className="product-details__number">
            Item #{selectedProduct.id}
        </TextPassage>
    );
}
